module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.onLine) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._l((_vm.tours), function(tour) {
    return _c('b-progress-bar', {
      key: tour.id,
      attrs: {
        "name": tour.name,
        "steps": tour.data,
        "callbacks": _vm.vueToursCallbacks(tour.id)
      }
    })
  }), _vm._v(" "), (_vm.IsProgressVisible) ? _c('md-progress', {
    staticClass: "md-accent",
    staticStyle: {
      "top": "64px"
    },
    attrs: {
      "md-indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('SideBar'), _vm._v(" "), _c('div', {
    class: parseInt(this.$sessionsStorage.get('userId')) > 0 ? _vm.ContentMargin == '250' ? 'appMargin300' : 'appMargin0' : ''
  }, [_c('div', {
    class: parseInt(this.$sessionsStorage.get('userId')) > 0 ? 'content-div' : ''
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('router-view')], 1)], 1)])], 2) : _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('ConnectionLost')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21b12f77","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/app.vue
// module id = 2458
// module chunks = 0